import React from "react";
import EastIcon from '@mui/icons-material/East';
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./Travelling-Condition.css";
import checkicon from "../../assets/images/check-mark-icon-symbols-vector-600nw-1906113508.webp";
import crossicon from "../../assets/images/exclude.png";



function TravallingCondition(props) {
  const importantPointsList = [
    {
      name: "Please ensure names of All guests are as per valid government Id proof as they will be used for booking all services.",
    },
    {
      name: "Air Tickets / Train Tickets (if included in the tour) will be as per names entered on website. Any chnages later will attract penalty.",
    },
    {
      name: "NRI's who do not possess an OCI card will have to bear additional (difference) cost over and Above tour price. NRI's who possess an OCI card will be exempt from this additional cost",
    },
    {
      name: "Guests are requested to issue their rail/air tickets only after speaking to their travel advisor. tour particulars such as Day, Date, Time must be cross checked prior to purchasing of tickets. Veena World shall not be liable for any loss/cancellation for faulty ticket issuance. The onus of re-issuing the tickets will lie solely upon the guest.",
    },
    {
      name: "Currently, we do not accept any online payments via international credit or debit cards or any other international transaction methods. If you wish to pay via international card or international money transfer, then please get in touch with our team for more details on 887 997 2221. Additional transaction charges may apply.",
    },
  ];

  const cancellationPoint = [
    {
      name: "All meals are provided by Ghoomo World in case the flight/train reaches the stipulated destination early morning or leaves destination late in the evening.",
    },
    {
      name: "In Case if any sightseeing is not done due to weekly closure, an alternative sightseeing will be done for the same.",
    },
    {
      name: "Standard Check-in and check-out time of International hotels is usually 1500hrs and 1200hrs respectively.",
    },
  ];

  const questionList = [
    {
      infoTitle: "General",
      questionDetails: [
        {
          question: "Can I book a tour online?",
          answer:
            "Yes, you can book a tour online by visiting our website, veenaworld.com and logging into your account.It’s simple to create an account on veenaworld.com. Click on ‘Sign In’ button and then select an option of “Register Now”. After filling in all necessary details, you can go ahead with booking tours.",
        },
        {
          question: "Can I select departure of my convenience?",
          answer:
            "Yes, once you click on Book Now, you can see a calendar with all available departure dates for that particular tour. You can select any departure date & go ahead with online booking.",
        },
        {
          question: "How to select room type depending on my odd group size?",
          answer:
            "You just have to enter the number of adults, children & infants traveling with you while filling in the booking form. Depending on your input, we shall display the available combinations of room types, from which you can select the one which suits you the most.",
        },
        {
          question: "How many people can be booked for a tour online?",
          answer:
            "You can book a tour for minimum one person & maximum for 6 people online.",
        },

        {
          question:
            "How can I complete my documentation if I book a tour online?",
          answer:
            "You can upload your necessary documents under ‘Guest Documents’ section in My Bookings in PDF or JPEG format.",
        },
        {
          question: "Can I reserve the seats online?",
          answer:
            "No, you cannot block/reserve any tour by email communication. In order to get book any tour, you have to fill up the Online Booking form & pay the required minimum amount.",
        },
      ],
    },

    {
      infoTitle: "Flights/Train",

      questionDetails: [
        {
          question: "Can I upgrade to business / first class?",
          answer:
            "You can upload your necessary documents under ‘Guest Documents’ section in My Bookings in PDF or JPEG format.",
        },
      ],
    },
    {
      infoTitle: "Special Requirements",

      questionDetails: [
        {
          question: "Can I avail prime seat option for bus online?",
          answer:
            "Yes, but it depends on availability. You can select prime seats if available & pay the price difference online while booking your tour.",
        },
      ],
    },
    ,
    {
      infoTitle: "Payments",

      questionDetails: [
        {
          question: "What online payment options do I get?",
          answer:
            "You can pay online using Credit / Debit Card & Net Banking with options of various banks.",
        },
        {
          question:
            "What if my payment fails & what might be the reason for it?",
          answer:
            "Failure of payment occurs because of multiple reasons such as debit/credit card’s daily transaction limit, entering wrong OTP, authentication failure from bank’s order etc. In such cases, if the amount gets deducted from your account, bank shall refund it as per their set process. You can get in touch with your bank for the same. Also, you can get in touch with our travel advisor for further assistance.",
        },
        {
          question: "Do I get refund on cancellation?",
          answer:
            "On tour cancellation, you are eligible for refund according to our “Cancellation Policy”. You can get the amount through Cheque or NEFT.",
        },
      ],
    },
  ];
  return (
    <>
      <div className="">
        <div className="mt-2">
          <Accordion className="mb-2">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Typography component="span" style={{ fontWeight: "600" }}>Inclusions</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <div>
                <ul className="inclusionlist">
                  {props?.packageDetails?.inclusionsList &&
                    props?.packageDetails?.inclusionsList.map((item) => (
                      <li key={item.inclusionsId}>
                        <div className="trip-inclusion">
                          <img
                            className="correct-icon"
                            src={checkicon}
                            alt=""
                          />
                          <span className="inclusion-name">
                            {item.inclusionsName}
                          </span>
                        </div>
                      </li>
                    ))}
                </ul>
              </div>
            </AccordionDetails>
          </Accordion>
          <Accordion className="mt-2 mb-2">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2-content"
              id="panel2-header"
            >
              <Typography component="span" style={{ fontWeight: "600" }}>Exclusions</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <div>
                <ul className="exclusionlist">
                  {props?.packageDetails?.exclusionsList &&
                    props?.packageDetails?.exclusionsList.map(
                      (item, index) => (
                        <li key={item.exclusionsId}>
                          <div className="trip-inclusion">
                            <img
                              className="cross-icon me-3"
                              src={crossicon}
                              alt=""
                            />
                            <span className="exclusion-name">
                              {item.exclusionsName}
                            </span>
                          </div>
                        </li>
                      )
                    )}
                </ul>
              </div>
            </AccordionDetails>
          </Accordion>
          <Accordion className="mt-2 mb-2">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2-content"
              id="panel2-header"
            >
              <Typography component="span" style={{ fontWeight: "600" }}>
                Frequently asked questions
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <div>
                {questionList.map((item) => (
                  <div key={item.question}>
                    <div className=" font-semibold mb-2 infoTitle" style={{ fontSize: '16px', fontWeight: '600', textDecoration: 'underline' }}>
                      {item.infoTitle}:
                    </div>
                    {item.questionDetails?.map((detail) => (
                      <>
                        <div className="font-semibold mb-2 infoTitle" style={{ fontSize: '13px', fontWeight: '600' }}>
                          {detail.question}
                        </div>
                        <ul className="otherdetails" style={{ listStyle: 'none', marginLeft: 3, padding: 0 }}>
                          <li className="mb-1 infopoints" key={detail.question} style={{ fontSize: '13px' }}>
                            <EastIcon style={{ height: '15px', width: '15px' }} /> {detail.answer}
                          </li>
                        </ul>
                      </>
                    ))}
                  </div>
                ))}
              </div>
            </AccordionDetails>
          </Accordion>
          <Accordion className="mt-2 mb-2">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2-content"
              id="panel2-header"
            >
              <Typography component="span" style={{ fontWeight: "600" }}>
                Cancellation & Payment terms
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <>
                <table class="cancellation-table">
                  <thead>
                    <tr>
                      <th>
                        Cancellation received no. of days prior to departure
                      </th>
                      <th>
                        Cancellation fee applicable on Net Tour Price (per
                        person)
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>D - 0 to 5</td>
                      <td>100%</td>
                    </tr>
                    <tr>
                      <td>D - 6 to 15</td>
                      <td>85%</td>
                    </tr>
                    <tr>
                      <td>D - 16 to 30</td>
                      <td>75%</td>
                    </tr>
                    <tr>
                      <td>D - 31 to 45</td>
                      <td>50%</td>
                    </tr>
                    <tr>
                      <td>D - 46 to 60</td>
                      <td>30%</td>
                    </tr>
                    <tr>
                      <td>D - 61 to 90</td>
                      <td>20%</td>
                    </tr>
                  </tbody>
                </table>
                <p className="mt-4" style={{ fontSize: '13px' }}>
                  Guest can pay by Cheque/ Demand Draft/ Debit card / Credit
                  card/ NEFT/ RTGS/ IMPS. For Debit / Credit card payment
                  additional 1.8 % convenience charge will be applicable Cheque
                  / Demand draft should be in favour of "Veena Patil Hospitality
                  Pvt ltd"
                </p>
                <div>
                  Remarks
                  <div>
                    {cancellationPoint.map((item) => (
                      <div key={item.name}>
                        <ul className="otherdetails list-disc pl-5">
                          <li className="mb-1 infopoints" style={{ fontSize: '13px' }}>{item.name}</li>
                        </ul>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            </AccordionDetails>
          </Accordion>
          <Accordion className="mt-2 mb-2">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2-content"
              id="panel2-header"
            >
              <Typography component="span" style={{ fontWeight: "600" }}>Important Points</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <div>
                {importantPointsList.map((item) => (
                  <div key={item.name}>
                    <ul className="otherdetails list-disc pl-5">
                      <li className="mb-1 infopoints" style={{ fontSize: '13px' }}>{item.name}</li>
                    </ul>
                  </div>
                ))}
              </div>
            </AccordionDetails>
          </Accordion>
        </div>
      </div>
    </>
  );
}
export default TravallingCondition;
